import { Paper, Stack, Typography, Button } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

export const AdminMessagesPage = () => (
  <Paper
    elevation={0}
    sx={{
      p: 4,
      borderRadius: 4,
      border: (theme) => `1px solid ${theme.palette.grey[200]}`,
      backgroundColor: "#fcfdff",
      minHeight: { xs: "50vh", md: "60vh" },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: 2,
    }}
  >
    <MailOutlineIcon sx={{ fontSize: 48, color: "primary.main" }} />
    <Stack spacing={1}>
      <Typography variant="h5" fontWeight={600}>
        Messages & Notifications
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Connect with designers and homeowners. Messaging tools are coming soon.
      </Typography>
    </Stack>
    <Button variant="contained" sx={{ borderRadius: 2 }}>
      Configure Alerts
    </Button>
  </Paper>
);

export default AdminMessagesPage;
